var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSession(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9606 12.5329L12.7865 9.09961H13.3389C13.6695 9.09961 13.9375 8.83159 13.9375 8.50098C13.9375 8.17036 13.6695 7.90234 13.3389 7.90234H13.0745L13.4617 6.29241C13.5517 5.9925 13.3698 5.61146 13.0358 5.53066C12.4873 5.39794 12.1276 5.83093 12.0281 6.07053L11.6397 7.90234H10.3887L10.0247 6.16048C9.97678 5.93193 9.74878 5.49469 8.99696 5.49469C8.31576 5.49469 8.05951 5.93193 8.01527 6.16048L7.64656 7.90234H6.39144L6.01185 6.10049C5.87988 5.82457 5.61499 5.41774 5.04012 5.53066C4.5447 5.62797 4.4911 6.05646 4.52427 6.24445L4.92503 7.90234H4.65332C4.3227 7.90234 4.05469 8.17036 4.05469 8.50098C4.05469 8.83159 4.3227 9.09961 4.65332 9.09961H5.21444L6.04435 12.5329C6.06278 12.7614 6.34775 13.2085 7.01749 13.2085C7.68723 13.2085 7.97221 12.7614 8.01275 12.5329L8.73004 9.09961H9.26688L9.99222 12.5329C10.0696 12.7614 10.2466 13.2085 11.0096 13.2085C11.6377 13.2085 11.9053 12.7614 11.9606 12.5329ZM11.0096 10.8741L11.3859 9.09961H10.6388L11.0096 10.8741ZM8.99696 7.82198L9.01394 7.90234H8.98017L8.99696 7.82198ZM7.01749 10.8741L7.39312 9.09961H6.64366L7.01749 10.8741Z",
    fill: "#777777"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9ZM9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9C16.5 13.1421 13.1421 16.5 9 16.5Z",
    fill: "#777777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSession);
export default __webpack_public_path__ + "static/media/Session.5b69b59e537d9d097dde33b1276fb474.svg";
export { ForwardRef as ReactComponent };